<style scoped>
    .state-generator-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
        gap: 20px;
        padding: 30px;
    }

    .state-generator-card {
        background: white;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 10, 20, 0.1);
        padding: 25px;
        cursor: pointer;
        transition: box-shadow 0.2s, transform 0.2s;
        border-left: 4px solid #1e73be;
    }

    .state-generator-card:hover {
        box-shadow: 0 4px 16px rgba(0, 10, 20, 0.2);
        transform: translateY(-2px);
    }

    .state-generator-card h3 {
        margin: 0 0 8px 0;
        color: #0D3B70;
        font-size: 15px;
        text-transform: uppercase;
    }

    .state-generator-card p {
        margin: 0;
        color: #78828C;
        font-size: 13px;
    }
</style>

<template>
    <CustomTopbar>
        <template v-slot:custom-topbar>
            <div id="topbar-button-container">
            </div>
        </template>
    </CustomTopbar>
    <div class="state-generator-grid">
        <div class="state-generator-card" @click="openModal('analyseCA')">
            <h3>Analyse CA</h3>
            <p>Factures et avoirs clients, détail par article facturé</p>
        </div>
        <div class="state-generator-card" @click="openModal('variationStock')">
            <h3>Variation de stock</h3>
            <p>Entrées et sorties de stock sur une période donnée</p>
        </div>
    </div>

    <Modal v-if="displayModal" @click.self="closeModal">
        <template v-slot:modalTitle>{{ modalTitle }}</template>
        <template v-slot:modalContent>
            <form class="form-column">
                <div v-if="currentState === 'analyseCA'">
                    <BaseDatepicker
                        v-model="filterValues.date_debut"
                        label="Date de début"
                    />
                    <BaseDatepicker
                        v-model="filterValues.date_fin"
                        label="Date de fin"
                    />
                    <BaseSelect
                        v-model="filterValues.establishment"
                        label="Établissement"
                        name="establishment"
                        :defaultOptions="establishments"
                    />
                </div>
                <div v-if="currentState === 'variationStock' || currentState === 'stateCaPerCustomer' || currentState === 'stateVariationsStock' || currentState === 'stateVariationsStock2'">
                    <BaseDatepicker
                        v-model="filterValues.date_debut"
                        label="Date de début"
                    />
                    <BaseDatepicker
                        v-model="filterValues.date_fin"
                        label="Date de fin"
                    />
                </div>
                <div v-if="currentState === 'stateFacturationParMois'">
                    <BaseDatepicker
                        v-model="filterValues.mois"
                        label="Mois"
                        :onlyMonth="true"
                    />
                </div>
                <div v-if="currentState === 'stateHeuresParAffaireParMois' || currentState === 'stateClientsCetrafact'">
                    <p style="color: #78828C;">Aucun filtre nécessaire pour cet export.</p>
                </div>
            </form>
        </template>
        <template v-slot:modalButtons>
            <BaseButton class="white-button" buttonText="Annuler" @click="closeModal" />
            <BaseButton class="orange-button" buttonText="Télécharger" @click="downloadCurrentState">
                <template v-slot:iconBefore>
                    <font-awesome-icon :icon="['fas', 'download']" />
                </template>
            </BaseButton>
        </template>
    </Modal>
    <Dialog ref="dialog"/>
</template>

<script>
import axios from 'axios';
import { format } from 'date-fns';
import BaseSelect from '@/components/Base/BaseSelect';
import CustomTopbar from '@/components/Topbar/CustomTopbar';
import Dialog from '@/components/App/Dialog';
import Modal from '@/components/App/Modal';
import BaseDatepicker from '@/components/Base/BaseDatepicker';
import BaseButton from '@/components/Base/BaseButton';

export default {
    name: 'stateGenerator',
    components: {
        BaseButton,
        BaseSelect,
        CustomTopbar,
        BaseDatepicker,
        Dialog,
        Modal
    },
    data() {
        return {
            displayModal: false,
            currentState: null,
            modalTitle: '',
            filterValues: {},
            establishments: [
                { label: 'Tous', value: '' },
                { label: 'EBC', value: 'ebc' },
                { label: 'SMG', value: 'smg' }
            ]
        }
    },
    methods: {
        openModal(stateType) {
            this.currentState = stateType;
            this.filterValues = {};

            const titles = {
                analyseCA: 'Analyse CA',
                variationStock: 'Variation de stock',
                stateCaPerCustomer: 'CA par client',
                stateVariationsStock: 'Variation des stocks (1)',
                stateVariationsStock2: 'Variation des stocks (2)',
                stateHeuresParAffaireParMois: 'Heures / affaires / mois',
                stateFacturationParMois: 'Facturation / mois',
                stateClientsCetrafact: 'Clients Cetrafact'
            };

            this.modalTitle = titles[stateType] || '';
            this.displayModal = true;
        },
        closeModal() {
            this.displayModal = false;
            this.currentState = null;
        },
        downloadCurrentState() {
            switch (this.currentState) {
                case 'analyseCA': this.downloadAnalyseCA(); break;
                case 'variationStock': this.downloadVariationStock(); break;
                case 'stateCaPerCustomer': this.downloadStateCaPerCustomer(); break;
                case 'stateVariationsStock': this.downloadStateVariationsStock(); break;
                case 'stateVariationsStock2': this.downloadStateVariationsStock2(); break;
                case 'stateHeuresParAffaireParMois': this.downloadStateHeuresParAffaireParMois(); break;
                case 'stateFacturationParMois': this.downloadStateFacturationParMois(); break;
                case 'stateClientsCetrafact': this.downloadStateClientsCetrafact(); break;
            }
        },
        formatDateToISO(dateStr) {
            if (!dateStr) return null;
            const parts = dateStr.split('/');
            if (parts.length === 3) {
                return `${parts[2]}-${parts[1]}-${parts[0]}`;
            }
            return dateStr;
        },
        buildDateParams() {
            let params = '';
            if (this.filterValues.date_debut) {
                params += `${params === '' ? '?' : '&'}startDateFilter=${this.formatDateToISO(this.filterValues.date_debut)}`;
            }
            if (this.filterValues.date_fin) {
                params += `${params === '' ? '?' : '&'}endDateFilter=${this.formatDateToISO(this.filterValues.date_fin)}`;
            }
            return params;
        },
        downloadAnalyseCA() {
            let params = this.buildDateParams();
            if (this.filterValues.establishment?.value) {
                params += `${params === '' ? '?' : '&'}establishment=${this.filterValues.establishment.value}`;
            }

            axios.get('stateGenerator/getAnalyseCA' + params, {
                showPreloader: true,
                toastError: true,
                responseType: 'blob'
            })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Analyse_CA_${format(new Date(), 'ddMMyyyy_HHmmss')}.xlsx`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
                this.closeModal();
            })
            .catch(() => {});
        },
        downloadVariationStock() {
            let params = this.buildDateParams();

            axios.get('stateGenerator/getVariationStock' + params, {
                showPreloader: true,
                toastError: true,
                responseType: 'blob'
            })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Variation_Stock_${format(new Date(), 'ddMMyyyy_HHmmss')}.xlsx`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
                this.closeModal();
            })
            .catch(() => {});
        },
        downloadStateCaPerCustomer() {
            let params = this.buildDateParams();

            axios.get('stateGenerator/getCaParClient' + params, {
                showPreloader: true
            })
            .then((response) => {
                const rowTitles = ["Intitulé", "Montant", "Pays", "Ass.Credit", "Date Exp.", "No Facture", "Date Fact."];
                this.downloadCsvFile(response.data.data, rowTitles, "Etat_ca_par_client");
                this.closeModal();
            })
            .catch(() => {});
        },
        downloadStateVariationsStock() {
            let params = this.buildDateParams();

            axios.get('stateGenerator/getVariationsStock' + params, {
                showPreloader: true
            })
            .then((response) => {
                const rowTitles = [
                    "Année Mvt", "Code+CC", "Famille", "Libellé 01", "Libellé 02",
                    "Nature Art", "Type Art", "Code Gest.", "Jour Mvt", "Lib.Mvt",
                    "N° Affaire", "qte Entrées", "qte Sorties", "Valeur entrées", "Valeur sorties"
                ];
                this.downloadCsvFile(response.data.data, rowTitles, "Etat_variation_stocks");
                this.closeModal();
            })
            .catch(() => {});
        },
        downloadStateVariationsStock2() {
            let params = this.buildDateParams();

            axios.get('stateGenerator/getVariationsStock2' + params, {
                showPreloader: true
            })
            .then((response) => {
                const rowTitles = [
                    "Code Article", "Libellé", "Libellé sur devis", "Qte Stock", "Prix Achat",
                    "Prix Vente", "Date mouvement", "Délai", "Cpt Achat", "Cpt Vente",
                    "Affiché sur le devis ?", "Géré en stock ?", "Famille", "Unité",
                    "Etablissement", "Nature", "Qte Entrées", "Qte Sorties"
                ];
                this.downloadCsvFile(response.data.data, rowTitles, "Etat_variation_stocks_2");
                this.closeModal();
            })
            .catch(() => {});
        },
        downloadStateHeuresParAffaireParMois() {
            axios.get('stateGenerator/getHeuresParAffaireParMois', {
                showPreloader: true
            })
            .then((response) => {
                const rowTitles = [
                    "N° AFFAIRE", "NOM CLIENT", "Lib 01 PF", "Lib 01 Cpt",
                    "Tps Realis", "Matricule", "Nom Matricule", "Date Réalisation"
                ];
                this.downloadCsvFile(response.data.data, rowTitles, "Etat_heures_par_affaire_par_mois");
                this.closeModal();
            })
            .catch(() => {});
        },
        downloadStateFacturationParMois() {
            let params = '';
            if (this.filterValues.mois) {
                params = `?monthFilter=${this.filterValues.mois}`;
            }

            axios.get('stateGenerator/getFacturationParMois' + params, {
                showPreloader: true
            })
            .then((response) => {
                const rowTitles = [
                    "N° FACTURE", "N° DE COMPTE CLIENT", "NOM CLIENT", "TTC", "TVA", "HT OU COMPTE"
                ];
                this.downloadCsvFile(response.data.data, rowTitles, "Etat_facturation_par_mois");
                this.closeModal();
            })
            .catch(() => {});
        },
        downloadStateClientsCetrafact() {
            axios.get('stateGenerator/getClientsCetrafact', {
                showPreloader: true
            })
            .then((response) => {
                const rowTitles = [
                    "Compte", "Abrege", "Nom", "Type tiers", "Decouvert1", "Date Debut",
                    "Date Fin 1", "E-Mail", "Teleph. 1", "Site Inter", "Cp Compt P",
                    "Rue1 Fact.", "Rue2 Fact.", "CP Facturé", "Ville Fact", "Pays Fact.",
                    "Rue1", "Rue2", "Code Post.", "Ville", "Pays", "Nom Livr.",
                    "Rue1 Livr.", "Rue2 Livr", "C. P. Livr", "Ville Livr", "Pays Livr.",
                    "Siret", "No TVA CEE", "APE", "Cpt Compta", "Sect.Activ",
                    "Code Tarif", "Code Taxe", "Rég.Fisc.", "Langue", "Code Rglt",
                    "Code Echea", "Base Echea"
                ];
                this.downloadCsvFile(response.data.data, rowTitles, "Etat_clients_cetrafact");
                this.closeModal();
            })
            .catch(() => {});
        },
        downloadCsvFile(rowsFromServer, rowTitles, filenamePrefix) {
            let csvContent = rowsFromServer
                .reduce((o, row) => {
                    const keys = Object.keys(row);
                    if (o.length === 0) {
                        o.push(rowTitles);
                    }
                    o.push(keys.reduce((obj, key) => {
                        obj.push(row[key] !== null ? `${('' + row[key]).replace(';', '').replace(',', '')}` : '');
                        return obj;
                    }, []));
                    return o;
                }, [])
                .map(e => e.join(";")).join("\n");

            this.exportCSV(csvContent, `${filenamePrefix}_`, true);
        }
    }
}
</script>
